import React, { Fragment, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

function Items({ currentItems }) {
  return (
    <>
      {currentItems}
    </>
  );
}

function PaginatedItems({ gridKeys, searchObjInit, searchObject, originalGrid, setGrid, dataCount, pageLimit, setPage, setPageLimit, requestSort, sortConfig, updateSearchData, gridrender,page, grid }) {


  // Invoke when user click to request another page.
  const handlePageClick = async (event) => {
    const currentPage = event.selected;
    setPage(currentPage);   
  };



  useEffect(() => {
    searchForSpecificKey();
    }, [searchObject])
  
  function compareObjects(o1, o2) {
    var k = '';
    for(k in o1) if(o1[k] != o2[k]) return false;
    for(k in o2) if(o1[k] != o2[k]) return false;
    return true;
  }
  
  function itemExists(haystack, needle) {
    for(var i=0; i<haystack.length; i++) if(compareObjects(haystack[i], needle)) return true;
    return false;
  }

  
  function searchForSpecificKey() {
    var results = [];
    //toSearch = trimString(toSearch); // trim it
    if(JSON.stringify(searchObject) !== JSON.stringify(searchObjInit)) {
        setPage(0);
        for(var i=0; i < originalGrid.length; i++) {
            for(var key in searchObject) {
                var kval = originalGrid[i][key] != null ? String(originalGrid[i][key]) : null;
                if(searchObject[key] != '') {
                    if(kval != null && kval.toLowerCase().indexOf(searchObject[key].toLowerCase()) != -1) {
                        if(!itemExists(results, originalGrid[i])) results.push(originalGrid[i]);
                    }
                }
            }
        }
        setGrid(results);
    } else {
        setGrid(originalGrid);
    }
  } 


  return (
    <>


      { grid }
      <br />

      <div className="paginations-display justify-content-center">

        <div>
          {dataCount && dataCount > 0 &&  <select type="date" className="form-select select-font-size" style={{color: '#e25a0c'}} onChange={(e) => { if(e.target.value != 0) {
              setPage(0);
              setPageLimit(e.target.value);
          }}}>
              <option value={0}>Page Limit</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
          </select>}
        </div>

        {
        dataCount && dataCount > 0 &&
          <>
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={Math.ceil(dataCount / pageLimit)}
              previousLabel="< Previous"
              renderOnZeroPageCount={null}
              marginPagesDisplayed={3}
              containerClassName={"pagination justify-paginations"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName="active"
            />  
            <div style={{ margin:'10px'}} className="mobile-pagination-placing">
                <span style={{color: '#e25a0c', margin:'5px', fontWeight: 'bold'}}>{page * pageLimit + 1} </span> - <span style={{color: '#e25a0c', margin:'5px', fontWeight: 'bold'}}>{Math.ceil(dataCount / pageLimit) === page + 1 ? dataCount : (1+page) * pageLimit}</span>
                Of <span style={{color: '#e25a0c', margin:'5px', fontWeight: 'bold'}}>{dataCount}</span> Records
            </div> 
          </>  
          }


      </div>
    </>
  );
}

export default PaginatedItems;
